import { Button } from "@core/button";
import { AlertCircle, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@core/text";

export const LoadingState = () => (
  <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700">
    <div className="animate-pulse space-y-4">
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
        </div>
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded"></div>
      </div>
    </div>
  </div>
);

export const ErrorState = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 dark:bg-red-900 mb-4">
          <AlertCircle size={32} className="text-red-600 dark:text-red-400" />
        </div>
        <Text variant={"h3"} className="mb-2">
          students.table.error.title
        </Text>
        <Text variant="p" status="secondary" className="mb-4">
          students.table.error.message
        </Text>
        <Button
          onClick={() => window.location.reload()}
          bgColor="bg-red-600 hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-800"
          textColor="text-white"
          variant="outline"
          rounded="md"
          size="md"
          className="border-transparent shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 dark:focus:ring-offset-gray-800"
        >
          {t("students.table.error.retry")}
        </Button>
      </div>
    </div>
  );
};

export const EmptyState = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 border border-gray-200 dark:border-gray-700">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900 mb-4">
          <Users size={32} className="text-blue-600 dark:text-blue-400" />
        </div>
        <Text variant={"h3"}>students.table.noData</Text>
        {/* <Button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-gray-800">
                    {t('students.actions.add')}
                </Button> */}
      </div>
    </div>
  );
};
